export default __webpack_public_path__ + "static/media/star-half-stroke.d0bb37c1.svg";